import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

const {
  RECHECK_DISCHARGE_OVERRIDE_STATUS_REQUEST,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE,
  RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING,
} = documentationActions;

function* recheckDischargeOverrideStatus(action: any): SagaReturnType<any> {
  try {
    yield put({ type: RECHECK_DISCHARGE_OVERRIDE_STATUS_LOADING });
    const response = yield call(templateService.recheckDischargeOverrideStatus);
    if (response?.status === 200) {
      yield put({ type: RECHECK_DISCHARGE_OVERRIDE_STATUS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: RECHECK_DISCHARGE_OVERRIDE_STATUS_FAILURE, payload: error });
  }
}

function* recheckDischargeOverrideStatusSaga() {
  yield takeEvery(RECHECK_DISCHARGE_OVERRIDE_STATUS_REQUEST, recheckDischargeOverrideStatus);
}

export default recheckDischargeOverrideStatusSaga;
